import type { TaskScope } from "@recobra/schemas/task-catalog";

import { type TaskName, useTaskTypes } from "./useTaskCatalog";

type ResolutionLabel = (taskType: string, resolutionId: string) => string;

/** How task types and their recorded resolutions read; `knows` is true until the catalog loads. */
export type TaskLabels = {
  taskName: TaskName;
  resolutionLabel: ResolutionLabel;
  knows: (taskType: string) => boolean;
};

/**
 * Names task types by id; with a scope, also by the code-owned key intake events and actions
 * use, resolved within that scope.
 */
export const useTaskLabels = (scope?: TaskScope | null): TaskLabels => {
  const { data } = useTaskTypes();
  const taskTypeOf = (key: string) =>
    data?.get(key) ??
    [...(data?.values() ?? [])].find(
      (taskType) => taskType.scope === scope && taskType.system === key,
    );
  return {
    knows: (key) => !data || taskTypeOf(key) !== undefined,
    taskName: (key) => taskTypeOf(key)?.name ?? key,
    resolutionLabel: (taskType, resolutionId) =>
      taskTypeOf(taskType)?.resolutions.find(({ id }) => id === resolutionId)?.label ??
      resolutionId,
  };
};
